import _ from 'lodash'
import notificationCampaignApi from '@/api/notification-campaign'
import store from '@/store'
import form from './form'
import recipients from './recipients'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    status: null,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    commit('LIST_LOADING')

    return notificationCampaignApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
      .catch(() => commit('SET_LIST', { items: [], metadata: { totalItemCount: 0 } }))
  },

  cancel({ dispatch }, id) {
    return notificationCampaignApi.cancel(id)
      .then(() => store.dispatch('message/success', 'Рассылка остановлена'))
      .catch(error => store.dispatch(
        'message/error',
        error.response?.data?.message || 'Не удалось остановить рассылку',
      ))
      .finally(() => dispatch('fetchList'))
  },
  sendNow({ dispatch }, id) {
    return notificationCampaignApi.sendNow(id)
      .then(() => store.dispatch('message/success', 'Рассылка поставлена на отправку'))
      .catch(error => store.dispatch(
        'message/error',
        error.response?.data?.message || 'Не удалось разослать',
      ))
      .finally(() => dispatch('fetchList'))
  },
}

const mutations = {
  LIST_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
  recipients,
}

const watchers = [
  [
    ({ notificationCampaign: { filters } }) => [filters.searchQuery, filters.status].join('|'),
    () => store.commit('notificationCampaign/FORM_UPDATE_FIELD', { key: 'filters.pageNumber', value: 1 }),
  ],
  [
    state => state.notificationCampaign.filters,
    _.debounce(async () => await store.dispatch('notificationCampaign/fetchList'), 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
